import Joi from "joi";
import errorsResolver from "../schemeUtils";

const COUPON_NAME_LENGTH = 200;

const createConditionalNumberValidation = (field) => {
    return Joi.number()
      .precision(2)
      .when(`/${field}`, {
        is: false,
        then: Joi.optional().allow(''),
        otherwise: Joi.required()
      })
      .error(errorsResolver({
        required: 'Обязательное поле',
        numberBase: 'Поле должно быть числом'
    }));
};

const createNumberValidation = (isRequired = true) => {
    const baseValidation = Joi.number()
        .precision(2)
        .min(0.01)
        .error(errorsResolver({
        numberMin: `Поле должно быть больше нуля`,
        numberBase: `Поле должно быть числом`,
        required: isRequired ? 'Обязательное поле' : undefined,
        }));

    if (isRequired) {
        return baseValidation.required();
    } else {
        return baseValidation.allow('').optional();
    }
};

export const createCouponScheme = (carsFeature, clientCategoryFeature, name, discountBonus, discountBirthday, timeLimit, isHybridAnnuity, isAnnuity) => {

    let rowsItemScheme = Joi.object({
        startPrice: Joi.number()
            .required()
            .precision(2)
            .error(errorsResolver({
                required: `Обязательное поле`,
                numberBase: `Поле должно быть числом`
            })),
        endPrice: Joi.number()
            .required()
            .precision(2)
            .error(errorsResolver({
                required: `Обязательное поле`,
                numberBase: `Поле должно быть числом`
            })),
        basePurity: Joi.number()
            .required()
            .when(Joi.ref('/purity'), {is: false, then: Joi.optional().allow('')})
            .precision(2)
            .error(errorsResolver({
                required: `Обязательное поле`,
                numberBase: `Поле должно быть числом`
            })),
        delayPurity: Joi.number()
            .required()
            .when(Joi.ref('/purity'), {is: false, then: Joi.optional().allow('')})
            .precision(2)
            .error(errorsResolver({
                required: `Обязательное поле`,
                numberBase: `Поле должно быть числом`
            })),
        baseThings: Joi.number()
            .required()
            .when(Joi.ref('/things'), {is: false, then: Joi.optional().allow('')})
            .precision(2)
            .error(errorsResolver({
                required: `Обязательное поле`,
                numberBase: `Поле должно быть числом`
            })),
        delayThings: Joi.number()
            .required()
            .when(Joi.ref('/things'), {is: false, then: Joi.optional().allow('')})
            .precision(2)
            .error(errorsResolver({
                required: `Обязательное поле`,
                numberBase: `Поле должно быть числом`
            })),
    })
    const bonusKey = isAnnuity ? 'baseAnnuityPercentBonus' : 'basePercentBonus';
    const birthdayKey = isAnnuity ? 'baseAnnuityPercentBirthday' : 'basePercentBirthday';
  
    rowsItemScheme = rowsItemScheme.keys({
      [bonusKey]: createNumberValidation(!!discountBonus),
      [birthdayKey]: createNumberValidation(!!discountBirthday),
    });
  
    let timeLimitValues = {};
    if (timeLimit) {
        timeLimitValues = {
            timeFrom: Joi.string()
                .required()
                .error(errorsResolver({
                    required: 'Обязательное поле'
                })),
            timeTo: Joi.string()
                .required()
                .error(errorsResolver({
                    required: 'Обязательное поле'
                }))
        };
    } else {
        timeLimitValues = {
            timeFrom: Joi.string().empty('').optional(),
            timeTo: Joi.string().empty('').optional()
        };
    }
    if (carsFeature) {
        rowsItemScheme = rowsItemScheme.keys({
            baseCars: Joi.number()
                .required()
                .when(Joi.ref('/cars'), {
                    is: false,
                    then: Joi.optional().allow('')
                })
                .precision(2)
                .error(errorsResolver({
                    required: `Обязательное поле`,
                    numberBase: `Поле должно быть числом`
                })),

            delayCars: Joi.number()
                .required()
                .when(Joi.ref('/cars'), {
                    is: false,
                    then: Joi.optional().allow('')
                })
                .precision(2)
                .error(errorsResolver({
                    required: `Обязательное поле`,
                    numberBase: `Поле должно быть числом`
                }))
        });
    }

    if (name) {
        rowsItemScheme = rowsItemScheme.keys({
            couponRowName: Joi.string()
                .max(COUPON_NAME_LENGTH)
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- .+]*$'))
                .error(errorsResolver({
                    max: `Наименование должно быть до ${COUPON_NAME_LENGTH} символов`,
                    required: `Наименование обязательное поле`,
                    pattern: `Наименование содержит некорректные символы`
                }))
        })
    }

    if (isHybridAnnuity) {
        rowsItemScheme = rowsItemScheme.keys({
            minAnnuityDuration: Joi.number()
            .required().empty('')
            .max(999999999)
            .min(0)
            .integer()
            .error(errorsResolver({
                numberUnsafe: `Поле должно быть корректным числом`,
                numberMin: `Поле должно быть больше нуля`,
                numberMax: `Поле должно быть меньше 99999999`,
                number: `Поле должно быть числом`,
                required: `Обязательное поле`,
                numberBase: `Поле должно быть числом`
            })),
            maxAnnuityDuration: Joi.number()
                .required().empty('')
                .max(999999999)
                .min(0)
                .integer()
                .greater(Joi.ref("minAnnuityDuration"))
                .error(errorsResolver({
                    numberUnsafe: `Поле должно быть корректным числом`,
                    numberMin: `Поле должно быть больше нуля`,
                    numberMax: `Поле должно быть меньше 99999999`,
                    number: `Поле должно быть числом`,
                    required: `Обязательное поле`,
                    numberBase: `Поле должно быть числом`,
                    numberGreater: `Максимальный срок должен быть больше минимального`,
                    ref: `Минимальный срок не указан`
                })),
            baseAnnuityPurity: createConditionalNumberValidation('purity'),
            delayAnnuityPurity: createConditionalNumberValidation('purity'),

            baseAnnuityThings: createConditionalNumberValidation('things'),
            delayAnnuityThings: createConditionalNumberValidation('things'),

            ...(carsFeature && {
                baseAnnuityCars: createConditionalNumberValidation('cars'),
                delayAnnuityCars: createConditionalNumberValidation('cars')
            })
        })
        if (discountBonus) {
            rowsItemScheme = rowsItemScheme.keys({
                basePercentBonus: createNumberValidation(),
                baseAnnuityPercentBonus: createNumberValidation()
            })
        } else {
            rowsItemScheme = rowsItemScheme.keys({
                basePercentBonus: createNumberValidation(false),
                baseAnnuityPercentBonus: createNumberValidation(false)
            })
        }
        if (discountBirthday) {
            rowsItemScheme = rowsItemScheme.keys({
                basePercentBirthday: createNumberValidation(),
                baseAnnuityPercentBirthday: createNumberValidation(),
            })
        } else {
            rowsItemScheme = rowsItemScheme.keys({
                basePercentBirthday: createNumberValidation(false),
                baseAnnuityPercentBirthday: createNumberValidation(false)
            })
        }
    }

    let couponSchema = Joi.object({
        couponName: Joi.string()
            .max(COUPON_NAME_LENGTH)
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- .+]*$'))
            .error(errorsResolver({
                max: `Название должно быть до ${COUPON_NAME_LENGTH} символов`,
                required: `Название обязательное поле`,
                pattern: `Название содержит некорректные символы`
            })),
        things: Joi.bool(),
        cars: Joi.bool(),
        discountBirthday: Joi.bool(),
        couponType: Joi.string().allow(null).optional(),
        discountBonus: Joi.bool(),
        purity: Joi.bool()
            .when('things', {
                is: Joi.boolean().valid(false), then: Joi.when(Joi.ref('cars'), {
                    is: Joi.bool().valid(false),
                    then: Joi.bool().valid(true)
                })
            })
            .error(errorsResolver({
                values: `Выберите наименование залога`
            })),
        permanent: Joi.bool(),
        timeLimit: Joi.bool(),
        extend: Joi.bool(),
        active: Joi.bool(),
        withoutRecalculation: Joi.bool(),
        percentFromAmount: Joi.number().when('things', {
            is: false,
            then: Joi.when('cars', {
                is: false,
                then: Joi.when('purity', {
                    is: true,
                    then: Joi.number()
                        .empty('')
                        .precision(2)
                        .max(1.3)
                        .min(0.01)
                        .error(errorsResolver({
                            numberMin: `Процент от оценки должен быть больше нуля`,
                            numberMax: `Процент от оценки должен быть меньше 1.3`,
                            numberBase: `Процент от оценки должен быть числом`
                        })),
                    otherwise: Joi.number()
                        .empty('')
                        .precision(2)
                        .max(1)
                        .min(0.01)
                        .error(errorsResolver({
                            numberMin: `Процент от оценки должен быть больше нуля`,
                            numberMax: `Процент от оценки может быть более 1 только для драг. металлов`,
                            numberBase: `Процент от оценки должен быть числом`
                        }))
                })
            }),
            otherwise: Joi.number()
                .empty('')
                .precision(2)
                .max(1)
                .min(0.01)
                .error(errorsResolver({
                    numberMin: `Процент от оценки должен быть больше нуля`,
                    numberMax: `Процент от оценки может быть более 1 только для драг. металлов`,
                    numberBase: `Процент от оценки должен быть числом`
                }))
        })
            .error(errorsResolver({
                values: ` `
            }))
            .empty('')
            .precision(2)
            .max(1)
            .min(0.01)
            .error(errorsResolver({
                numberMin: `Процент от оценки должен быть больше нуля`,
                numberMax: `Процент от оценки должен быть меньше 1`,
                numberBase: `Процент от оценки должен быть числом`
            })),
        startDate: Joi.date()
            .required()
            .greater('01/01/2000')
            .error(errorsResolver({
                dateRequired: `Некорректная дата начала`,
                dateFormat: `Некорректная дата начала`,
                dateGreater: `Некорректная дата начала`,
            })),
        endDate: Joi.date()
            .required()
            .greater(Joi.ref("startDate"))
            .max('01/01/2100')
            .error(errorsResolver({
                dateFormat: `Некорректная дата окончания`,
                dateRequired: `Некорректная дата окончания`,
                dateGreater: `Дата окончания должна быть больше даты начала`,
                ref: `Дата начала не указана`
            })),
        timeFrom: Joi.string()
            .when('timeLimit', {
                is: true,
                then: Joi.string().required()
                    .error(errorsResolver({
                        required: 'Поле обязательно',
                    })),
                otherwise: Joi.string().optional().allow(null).empty('').pattern(/^[0-2]\d:[0-5]\d$/)
                    .error(errorsResolver({
                        pattern: 'Некорректный формат времени, ожидается HH:MM'
                    }))
            }),
        timeTo: Joi.string()
            .when('timeLimit', {
                is: true,
                then: Joi.string().required()
                    .error(errorsResolver({
                        required: 'Поле обязательно',
                    })),
                otherwise: Joi.string().optional().allow(null).empty('').pattern(/^[0-2]\d:[0-5]\d$/)
                    .error(errorsResolver({
                        pattern: 'Некорректный формат времени, ожидается HH:MM'
                    }))
            }),
        minDuration: Joi.number()
            .required().empty('')
            .max(999999999)
            .min(0)
            .integer()
            .error(errorsResolver({
                numberUnsafe: `Минимальный срок должен быть корректным числом`,
                numberMin: `Минимальный срок должен больше нуля`,
                numberMax: `Минимальный срок должен быть меньше 99999999`,
                number: `Минимальный срок должен быть числом`,
                required: `Минимальный срок обязательное поле`,
                numberBase: `Минимальный срок должен быть числом`
            })),
        maxDuration: Joi.number()
            .required().empty('')
            .max(999999999)
            .min(0)
            .integer()
            .greater(Joi.ref("minDuration"))
            .error(errorsResolver({
                numberUnsafe: `Максимальный срок должен быть корректным числом`,
                numberMin: `Максимальный срок должен больше нуля`,
                numberMax: `Максимальный срок должен быть меньше 99999999`,
                number: `Максимальный срок должен быть числом`,
                required: `Максимальный срок обязательное поле`,
                numberBase: `Максимальный срок должен быть числом`,
                numberGreater: `Максимальный срок должен быть больше минимального`,
                ref: `Минимальный срок не указан`
            })),
        updateOnBase: Joi.bool(),
        extendPercent: Joi.number()
            .when(Joi.ref('/updateOnBase'), {not: true, then: Joi.optional().empty(['', null])})
            .precision(2)
            .error(errorsResolver({
                required: `Процент от базовго обязательное поле`,
                numberBase: `Процент от базовго должен быть числом`
            })),
        rows: Joi.array().items(rowsItemScheme)
    });

    if (clientCategoryFeature) {
        couponSchema = couponSchema.keys({
            category: Joi.object({value: Joi.number(), label: Joi.any()}).allow(''),
        });
    }
    return couponSchema
}
